/**
 * Rewrites a plain search query into a field-scoped query before the search form submits.
 *
 * The storefront search returns the entire catalog for any term, so scoping each word to
 * title, product type and tag is what narrows the results.
 */

const FIELDS = ['title', 'product_type', 'tag'];

/** Queries that already use search syntax are passed through untouched. */
const ADVANCED_QUERY = /[:()"*]|\b(?:AND|OR|NOT)\b/;

/**
 * Builds the query to send to the search endpoint.
 *
 * @param {string} raw - The text the shopper typed.
 * @returns {string} The field-scoped query, or the original text.
 */
export function scopeSearchQuery(raw) {
  const query = raw.trim();

  if (query === '' || ADVANCED_QUERY.test(query)) return query;

  return query
    .split(/\s+/)
    .map((term) => `(${FIELDS.map((field) => `${field}:${term}`).join(' OR ')})`)
    .join(' AND ');
}

document.addEventListener('submit', (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement) || !form.action.includes('/search')) return;

  const input = form.querySelector('input[name="q"]');

  if (!(input instanceof HTMLInputElement)) return;

  const scoped = scopeSearchQuery(input.value);

  if (scoped === input.value.trim()) return;

  event.preventDefault();

  const params = new URLSearchParams(/** @type {any} */ (new FormData(form)));
  params.set('q', scoped);

  const url = new URL(form.action, window.location.origin);
  url.search = params.toString();

  window.location.assign(url.toString());
});
